// Admin Header.

import * as React from 'react';
import { useState, useEffect, useLayoutEffect } from 'react';
// import {useNavigate} from 'react-router-dom';
import Config from '../../lib/Config';
import Util from '../../lib/Util';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import AppBar from '@mui/material/AppBar';
// import AppBar from './';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
import MenuIcon from '@mui/icons-material/Menu';
import IconButton from '@mui/material/IconButton';
import { Avatar } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import AppBarTitle from './AppBarTitle';


import DashboardIcon from '@mui/icons-material/Dashboard';
import MapIcon from '@mui/icons-material/Map';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import PeopleIcon from '@mui/icons-material/People';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import CategoryIcon from '@mui/icons-material/Category';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import ReceiptIcon from '@mui/icons-material/Receipt';
import AnnouncementIcon from '@mui/icons-material/Announcement';
import LiveHelpIcon from '@mui/icons-material/LiveHelp';
import EmailIcon from '@mui/icons-material/Email';
import SettingsIcon from '@mui/icons-material/Settings';
import ScienceIcon from '@mui/icons-material/Science';
import UIString from '../../assets/content/UIString';







import { makeStyles } from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material';

const theme = createTheme({
    components: {
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    '&.Mui-selected': {
                        backgroundColor: '#ff0000', // Background color for selected items
                    },
                    '&:hover': {
                        backgroundColor: '#00ff00', // Background color for hovered items
                    },
                    '&.Mui-selected:hover': {
                        backgroundColor: '#0000ff', // Background color for selected + hovered items
                    },
                },
            },
        },
    },
});

{/* 182b47 */ }

let menu_items = [
    { label: 'Dashboard', link: '/admin/dashboard', code: 'dashboard', active_icon: <DashboardIcon style={{ fontSize: '18px', minWidth: '36px', background: 'transparent', color: '#28374f', fontWeight: 'bold' }} />, inactive_icon: <DashboardIcon style={{ fontSize: '18px', minWidth: '36px', background: 'transparent', color: '#999999' }} /> },
    { label: 'Mobile App', link: '/admin/mobile_app', code: 'mobile_app', active_icon: <PhoneAndroidIcon style={{ fontSize: '18px', minWidth: '36px', background: 'transparent', color: '#28374f', fontWeight: 'bold' }} />, inactive_icon: <PhoneAndroidIcon style={{ fontSize: '18px', minWidth: '36px', background: 'transparent', color: '#999999' }} /> },
    { label: 'User', link: '/admin/user', code: 'user', active_icon: <PeopleIcon style={{ fontSize: '18px', minWidth: '36px', background: 'transparent', color: '#28374f', fontWeight: 'bold' }} />, inactive_icon: <PeopleIcon style={{ fontSize: '18px', minWidth: '36px', background: 'transparent', color: '#999999' }} /> },
    { label: 'Corp', link: '/admin/corp', code: 'corp', active_icon: <CorporateFareIcon style={{ fontSize: '18px', minWidth: '36px', background: 'transparent', color: '#28374f', fontWeight: 'bold' }} />, inactive_icon: <CorporateFareIcon style={{ fontSize: '18px', minWidth: '36px', background: 'transparent', color: '#999999' }} /> },
    { label: 'Corp User', link: '/admin/corp_user', code: 'corp_user', active_icon: <AccountBoxIcon style={{ fontSize: '18px', minWidth: '36px', background: 'transparent', color: '#28374f', fontWeight: 'bold' }} />, inactive_icon: <AccountBoxIcon style={{ fontSize: '18px', minWidth: '36px', background: 'transparent', color: '#999999' }} /> },
    { label: 'Service & Product', link: '/admin/services', code: 'service_and_product', active_icon: <CategoryIcon style={{ fontSize: '18px', minWidth: '36px', background: 'transparent', color: '#28374f', fontWeight: 'bold' }} />, inactive_icon: <CategoryIcon style={{ fontSize: '18px', minWidth: '36px', background: 'transparent', color: '#999999' }} /> },
    { label: 'Bookmark', link: '/admin/bookmark', code: 'bookmark', active_icon: <BookmarkIcon style={{ fontSize: '18px', minWidth: '36px', background: 'transparent', color: '#28374f', fontWeight: 'bold' }} />, inactive_icon: <BookmarkIcon style={{ fontSize: '18px', minWidth: '36px', background: 'transparent', color: '#999999' }} /> },
    { label: 'Analytics', link: '/admin/analytics', code: 'analytics', active_icon: <AnalyticsIcon style={{ fontSize: '18px', minWidth: '36px', background: 'transparent', color: '#28374f', fontWeight: 'bold' }} />, inactive_icon: <AnalyticsIcon style={{ fontSize: '18px', minWidth: '36px', background: 'transparent', color: '#999999' }} /> },
    { label: 'Billing', link: '/admin/billing', code: 'billing', active_icon: <ReceiptIcon style={{ fontSize: '18px', minWidth: '36px', background: 'transparent', color: '#28374f', fontWeight: 'bold' }} />, inactive_icon: <ReceiptIcon style={{ fontSize: '18px', minWidth: '36px', background: 'transparent', color: '#999999' }} /> },
    { label: 'Notice', link: '/admin/notice/list/1', code: 'notice', active_icon: <AnnouncementIcon style={{ fontSize: '18px', minWidth: '36px', background: 'transparent', color: '#28374f', fontWeight: 'bold' }} />, inactive_icon: <AnnouncementIcon style={{ fontSize: '18px', minWidth: '36px', background: 'transparent', color: '#999999' }} /> },
    { label: 'Inquiries', link: '/admin/inquiry/list/1', code: 'inquiry', active_icon: <LiveHelpIcon style={{ fontSize: '18px', minWidth: '36px', background: 'transparent', color: '#28374f', fontWeight: 'bold' }} />, inactive_icon: <LiveHelpIcon style={{ fontSize: '18px', minWidth: '36px', background: 'transparent', color: '#999999' }} /> },
    { label: 'Messages', link: '/admin/message', code: 'message', active_icon: <EmailIcon style={{ fontSize: '18px', minWidth: '36px', background: 'transparent', color: '#28374f', fontWeight: 'bold' }} />, inactive_icon: <EmailIcon style={{ fontSize: '18px', minWidth: '36px', background: 'transparent', color: '#999999' }} /> },
    { label: 'Settings', link: '/admin/setting', code: 'setting', active_icon: <SettingsIcon style={{ fontSize: '18px', minWidth: '36px', background: 'transparent', color: '#28374f', fontWeight: 'bold' }} />, inactive_icon: <SettingsIcon style={{ fontSize: '18px', minWidth: '36px', background: 'transparent', color: '#999999' }} /> },
    { label: 'Template', link: '/admin/template', code: 'template', active_icon: <ScienceIcon style={{ fontSize: '18px', minWidth: '36px', background: 'transparent', color: '#28374f', fontWeight: 'bold' }} />, inactive_icon: <ScienceIcon style={{ fontSize: '18px', minWidth: '36px', background: 'transparent', color: '#999999' }} /> },
    { label: 'Map Test', link: '/admin/map', code: 'map_test', active_icon: <ScienceIcon style={{ fontSize: '18px', minWidth: '36px', background: 'transparent', color: '#28374f', fontWeight: 'bold' }} />, inactive_icon: <ScienceIcon style={{ fontSize: '18px', minWidth: '36px', background: 'transparent', color: '#999999' }} /> },
];
const drawerWidth = 200;
const lang = Util.get_lang();


export default function ClippedDrawer(props) {

    const [flagMenu, setFlagMenu] = useState(false);
    const [adminProfile, setAdminProfile] = useState({});
    // const navigate = useNavigate();

    const goto_page = (t) => {
        // document.location.href = t;
        if (t == '/admin/map') { document.location.href = t; } else {
            // alert(Config.base_url + t);return;
            //navigate(Config.base_url + t);
            document.location.href = Config.BASE_URL + t;
        }

        //props.navigation.push(t);
    }

    const toggle_menu = () => {
        setFlagMenu(!flagMenu);
    };

    const close_menu = () => {
        setFlagMenu(false);
    }


    useEffect(() => {

        document.title = Config.SERVICE_TITLE;
        if (!Config.SERVICE_LANGUAGES.includes(Util.get_url_lang())) {
            window.document.location = '/';
        };

        Util.get(
            //Config.API_BASE_URL + '/admin/account/profile',
            Util.api_url(lang,'/admin/account/profile'),
            (data) => {
                setAdminProfile(data);
            },
            (msg) => {
                alert(msg);
                document.location.href = Config.BASE_URL + '/admin/login';
            }
        );

    }, []);

    const logout = () => {
        let form = new FormData();
        Util.post(
            //            Config.API_BASE_URL + '/admin/auth/logout',
            Util.api_url(lang, '/admin/auth/logout'),
            form,
            (data) => {
                //document.location.href = Config.BASE_URL + '/admin/login';
                document.location.href = Util.page_url(lang,'/admin/login');
            },
            (msg) => {
                //alert(msg);
                //document.location.href = Config.BASE_URL + '/admin/login';
                document.location.href = Util.page_url(lang,'/admin/login');
            }
        );
    }


    return (
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            {/*<AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        
        <Toolbar>
          <Typography variant="h6" noWrap component="div">
            Clipped drawer
          </Typography>
        </Toolbar>
      </AppBar>*/}

            {/*  002663 2e3f59  */}

            <Box sx={{ flexGrow: 1 }}>
                <AppBar position="fixed" style={{ backgroundColor: '#ffffff' }} sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
                    <Toolbar variant="dense">
                        <IconButton edge="start" color="inherit" aria-label="menu" sx={{ mr: 2 }} onClick={() => { toggle_menu() }} >
                            <MenuIcon style={{ color: '#222222', fontSize: '18px' }} />
                        </IconButton>
                        <AppBarTitle />

                        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>

                            <Select

                                displayEmpty
                                variant="outlined"
                                sx={{
                                    paddingTop: '2px',
                                    backgroundColor: '#transparent', // Grey background
                                    height: '40px',             // Fixed height
                                    borderRadius: 1,            // Optional: slightly rounded corners
                                    '& .MuiOutlinedInput-notchedOutline': {
                                        border: 'none',           // No border
                                    },
                                    '& .MuiSelect-select': {
                                        paddingLeft: '12px',      // Padding similar to TextField
                                        fontSize: '12px',         // Font size for placeholder text
                                    },
                                    '& .MuiSelect-icon': {
                                        color: '#757575',         // Color for dropdown arrow
                                    },

                                    '& .MuiMenuItem-root.Mui-selected': {
                                        backgroundColor: '#ffffff', // Background color when an item is selected
                                    },
                                    '& .MuiMenuItem-root:hover': {
                                        backgroundColor: '#f1f1f1', // Hover state color
                                    },

                                    '& .MuiMenuItem-root.Mui-selected': {
                                        backgroundColor: '#ffffff', // Change the background color of selected item
                                    },
                                    '& .MuiMenuItem-root:hover': {
                                        backgroundColor: '#00ff00', // Optional: hover effect for items
                                    },

                                    //'& .MuiSelect-select': {
                                    //  color: 'red', // Text color of the selected item
                                    //  backgroundColor: '#00ff00', // Background color of the selected item
                                    //    },
                                    //  '& .MuiOutlinedInput-notchedOutline': {
                                    //    borderColor: 'green', // Border color of the select box
                                    //  },
                                    //   '& .MuiSelect-icon': {
                                    //     color: 'blue', // Color of the dropdown arrow
                                    //   },

                                }}
                                renderValue={(selected) => (selected ? selected : <span style={{ color: '#2e2e2e' }}>{UIString[lang]['ADMIN_PROFILE_DESC']}</span>)}
                                MenuProps={{
                                    sx: {

                                        '& .MuiPaper-root': {
                                            width: '200px',
                                            marginTop: '8px', // Moves the dropdown menu down by 10px
                                            marginRight: '-28px',
                                        },
                                    },
                                }}
                            >

                                <div style={{ padding: '8px', fontSize: '12px', lineHeight: '22px', marginTop: '-8px', paddingLeft: '14px', paddingRight: '14px', paddingTop: '12px' }}>
                                    <span>•&nbsp;{adminProfile.admin_user_name}<br />•&nbsp;{adminProfile.admin_user_email}<br /></span>
                                    <div style={{ width: '100%', height: '20px', textAlign: 'right', cursor: 'pointer', marginTop: '12px' }} onClick={logout}>{UIString[lang]['LOGOUT']}</div>

                                </div>
                                {/*<MenuItem value={10} sx={{ fontSize: '13px' }} >Option ?<br />Option 1<br />Option 1<br />Option 1<br /></MenuItem>
                               
                                <MenuItem value={1} sx={{ fontSize: '13px',height:'22px',marginTop:'8px' }} >{adminProfile.admin_user_name}</MenuItem>
                                <MenuItem value={2} sx={{ fontSize: '13px',height:'22px' }} >{adminProfile.admin_user_email}</MenuItem>
                                <MenuItem value={3} sx={{fontSize:'12px', width:'100%',textAlign:'right',justifyContent:'end',cursor:'pointer'}} >{UIString[lang]['LOGOUT']}</MenuItem>*/}
                                {/*<MenuItem value={30} >Option 3</MenuItem>*/}
                            </Select>





                            <IconButton color="inherit" sx={{}}>
                                <Avatar style={{ width: '26px', height: '26px', marginRight: '-14px' }} src={Util.api_url(lang, '/admin/account/profile/image')} alt="User Account" />
                            </IconButton>
                        </Box>
                    </Toolbar>
                </AppBar>
            </Box>
            <Drawer

                sx={{
                    width: drawerWidth,
                    flexShrink: 0,
                    [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box' },


                }}
                anchor='left'
                open={flagMenu}
                onClick={() => { close_menu(); }}
            >

                <Box sx={{ overflow: 'auto' }} style={{ backgroundColor: '#ffffff', paddingTop: '42px' }} >
                    <List style={{ paddingTop: '6px' }}>
                        {menu_items.map((item, index) => (
                            <ListItem key={item.code} disablePadding style={{ backgroundColor: '#ffffff' }}>
                                <ListItemButton style={{ height: '48px', cursor: 'pointer', left: '0px', width: '260px' }} onClick={() => { goto_page(item.link) }}>
                                    <ListItemIcon style={{ backgroundColor: '#ffffff', minWidth: '36px', background: 'transparent' }}>
                                        {props.code == item.code ? item.active_icon : item.inactive_icon}
                                    </ListItemIcon>
                                    {props.code == item.code ? <ListItemText><span style={{ fontSize: '13px', color: '#222222', fontWeight: 'bold' }}>{item.label}</span></ListItemText> : <ListItemText><span style={{ fontSize: '13px', color: '#afafaf' }}>{item.label}</span></ListItemText>}
                                </ListItemButton>
                            </ListItem>
                        ))}
                    </List>

                    {/*<Divider />
                    <List>
                        {['All mail', 'Trash', 'Spam'].map((text, index) => (
                            <ListItem key={text} disablePadding>
                                <ListItemButton>
                                    <ListItemIcon style={{ minWidth: '20px' }}>
                                        {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
                                    </ListItemIcon>
                                    <ListItemText primary={text} sx={{ fontSize: '9px' }} />
                                </ListItemButton>
                            </ListItem>
                        ))}
                    </List>*/}
                </Box>
            </Drawer>

        </Box>
    );
}